module.exports = __webpack_public_path__ + "img/code-com.eee58755.png";